<div style="height: 100dvh; width: 100%;" class="d-flex align-content-center justify-content-center">
  <div class="w-lg-50 w-sm-90 h-100 d-flex flex-column align-items-center justify-content-center gap-4">
    <header style="width: 100%;" class="brand d-flex flex-column align-items-center mb-4 gap-4">
      <div class="brand__logo-wrapper d-flex justify-content-center">
        <img class="brand__logo" [src]="logoUrl" alt="Brand logo" />
      </div>

      <!-- Environment-based subtitle -->
      @if (env === 'dqvademecum') {
        <p-chip class="brand__chip" label="dq VADEMECUM" icon="pi pi-sparkles"></p-chip>
      } @else if (env === 'ava' || env === 'avafitogest') {
        <p-chip class="brand__chip" label="Associació Valenciana d'Agricultors" icon="pi pi-users"></p-chip>
      }
    </header>

    <section class="auth">
      <p-card>
        <div>

          @if (error) {
            <p-message severity="error" text="Usuario o contraseña incorrectos" class="mb-3"></p-message>
          }

          @if (success) {
            <p-message severity="info" text="Redirigiendo…" class="mb-3"></p-message>
          }

          @if (status === 'paid') {
            <p-message severity="info" class="mb-3">
              La suscripción se ha realizado con éxito.<br>
              Procede a iniciar sesión para empezar con la gestión de tus explotaciones.
            </p-message>
          }
          
          <form class="form d-flex flex-column gap-3" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

            <div class="form__group">
              <label for="username" class="form__label">Usuario</label>

              @if (isDirectUserInput) {
                <!-- Direct input -->
                <div class="p-inputgroup">
                  <input id="username" pInputText formControlName="username" placeholder="Usuario..."
                    autocomplete="username" (keyup.enter)="onSubmit()" />
                </div>
              } @else {
                <!-- Dropdown selection -->
                <p-select id="username-select" [options]="userList.values || []" optionLabel="label"
                  optionValue="value.id" [filter]="true" filterPlaceholder="Buscar…" formControlName="userId"
                  placeholder="Seleccionar usuario…" showClear="true" [virtualScroll]="true" [virtualScrollItemSize]="36"
                  styleClass="w-full">
                </p-select>
              }
            </div>

            <!-- Password -->
            <div class="form__group">
              <label for="password" class="form__label">Contraseña</label>
              <p-password inputId="password" formControlName="password" placeholder="Contraseña…" [feedback]="false"
                [toggleMask]="true" [inputStyle]="{ width: '100%' }" [style]="{ width: '100%' }">
              </p-password>
            </div>

            <!-- Submit button -->
            <div class="form__actions">
              <p-button type="submit" styleClass="p-button-lg p-button-rounded"
                [style]="{ width: '20rem', background: 'blue', border: 'none' }"
                [disabled]="form.invalid || isDoLoginLoading || success" [label]="success ? 'Redirigiendo…' : 'Entrar'"
                [icon]="isDoLoginLoading ? 'pi pi-spin pi-spinner' : 'pi pi-sign-in'">
              </p-button>
            </div>

            <!-- Links -->
            <div class="d-flex justify-content-between">
              @if (canRecoverPassword) {
                <p-button label="Recuperar contraseña" styleClass="p-button-text p-button-sm p-button-secondary"
                  (onClick)="recuperarContrasenya()">
                </p-button>
              }
              @if (canRegister) {
                <p-button label="Crear cuenta" styleClass="p-button-sm p-button-rounded p-button-success"
                  (onClick)="crearCuenta()">
                </p-button>
              }
            </div>


            @if (success) {
              <p class="form__hint">
                Si no se redirige automáticamente, haga clic
                <a [routerLink]="['dashboard','inicio']">aquí</a>.
              </p>
            }
          </form>
        </div>
      </p-card>
    </section>
  </div>
  <!-- ===== Watermark ===== -->
  @if (showWatermark) {
    <a class="watermark" href="https://locatec.es/" target="_blank"
      title="Aplicación creada por Locatec. Todos los derechos reservados.">
      <img [src]="urlLogoLocatec" alt="Locatec.es" />
    </a>
  }
</div>


